import { CategoryDownloadDto, ElementNode, FetchPostsFilter, PostController, PostDownloadDto } from "collaboration-service";
import { Button, getColor, Icon, lightenColor, LoaderInline, styled } from "imaginarity-react-ui";
import * as React from "react";
import Autosuggest, { SuggestionsFetchRequestedParams } from "react-autosuggest";
//import { useSelector } from "react-redux";
import { useAppSelector } from "services/ApplicationState/ApplicationState";
import { reducerBatchJob, reducerSetIfChanged, stripHtml } from "services/Helpers";
import { useImgI18N } from "services/ImgI18N";
import useSearchableFeed from "views/UseSearchableFeed/UseSearchableFeed";
//import { shallowCompare } from "services/Helpers";
//import { useImgI18N } from "services/ImgI18N";
import AutocompleteSearch from "components/AutocompleteSearch/AutocompleteSearch";
import * as _ from "lodash";
import ScrollHelper from "services/Helpers/ScrollHelper";
import { getTranslated } from "services/Helpers/TranslationHelpers";
import { ThemeContext } from "styled-components";
import { TubeSC } from "views/Tube/TubeSC";


interface TubeSearchProps {
    onSearch?: (val: string) => void;
    accent?: string;
    categoryStack?: ElementNode<CategoryDownloadDto>[];
    categories?: CategoryDownloadDto[];
    filter: FetchPostsFilter;
}

const SearchField = (p: TubeSearchProps) => {
    const [search, setSearch] = React.useState<string>();
    const [suggestions, setSuggestions] = React.useState<string[]>([]);
    const { t } = useImgI18N("general");
    const { onSearch, categoryStack, filter } = p;
    const theme = React.useContext(ThemeContext);
    //const globalsearch = p.search;
    React.useEffect(() => {
        setSearch("");
        setSuggestions([]);
    }, [categoryStack])

    // React.useEffect(() => {
    //     setSearch(globalsearch);
    // }, [globalsearch]);

    const onEnterPressed = React.useMemo(() => () => {
        //console.log("onEnterPressed");

        if (onSearch)
            onSearch(search ?? "");
        //dispatch(Actions.setGlobalSearchSearch(search));
    }, [onSearch, search, /*dispatch*/]);

    const onSuggestionSelected = React.useMemo(() => (e: any, data: { suggestion: string }) => {
        //console.log("onSuggestionSelected");

        if (search) {
            const prefixEnd = search.lastIndexOf(" ");
            let prefix = "";
            if (prefixEnd >= 0)
                prefix = search.slice(0, prefixEnd) + " ";
            const s = `${prefix}${data.suggestion}`;
            //console.log('TubeSearch.tsx:92:s => ', s);
            if (onSearch)
                onSearch(s);
            //dispatch(Actions.setGlobalSearchSearch(s));
        }
    }, [onSearch, search, /*dispatch*/]);

    const onSuggestionsFetchRequested = React.useMemo(() => _.debounce((request: SuggestionsFetchRequestedParams) => {
        //console.log("onSuggestionsFetchRequested", filter);

        if (request.reason === "input-changed" || request.reason === "input-focused") {
            let terms = request.value.split(" ");
            terms = _.filter(terms, t => t.length > 0);
            const lastTerm = _.last(terms);

            // if (lastTerm)
            //     PostController.SuggestPostTerm1({ term: lastTerm, filter }, setSuggestions);

            if (lastTerm) {
                PostController.SuggestPostTerm2({ term: lastTerm, filter }, suggestions => {
                    setSuggestions(suggestions);
                });
            }


        }
    }, 250), [setSuggestions, filter]);

    const lm = true;
    const searchChanged = React.useMemo(() => (event: React.FormEvent<any>, params: Autosuggest.ChangeEvent) => {
        setSearch(params.newValue);
        //console.log('TubeSearch.tsx:108:params.newValue => ', params.newValue);
    }, [setSearch]);

    const resetSearchStr = React.useMemo(() => () => {
        setSearch("");
        //console.log('TubeSearch.tsx:112:resetSearch => ');
        if (onSearch)
            onSearch("");
    }, [onSearch, setSearch]);

    const onSuggestionsClearRequested = React.useMemo(() => () => {
        //console.log('onSuggestionsClearRequested.tsx:162:onSuggestionsClearRequested');

        setSuggestions([]);
    }, [setSuggestions]);
    return (
        <TubeSC.TSAuto suggested={suggestions.length > 0 ? suggestions.length + 1 : 0} lightMode={lm} accent={p.accent}>
            <AutocompleteSearch
                placeholder={t("search..")}
                onSuggestionSelected={onSuggestionSelected}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                search={search ?? ""}
                searchChanged={searchChanged}
                suggestions={suggestions}
                theme={{
                    container: { position: "relative" },
                    suggestionsContainer: {
                        display: "none",
                        width: "100%",
                        background: lm ? "@middleLightGrey" : "#0A0A0B",
                        backgroundColor: lm ? "@middleLightGrey" : "#0A0A0B",
                        marginLeft: 0,
                        boxShadow: "0 6px 8px -6px #000",
                    },
                    suggestionsContainerOpen: {
                        background: lm ? "#e9e9e9" : "#0A0A0B",
                        backgroundColor: lm ? "#e9e9e9" : "#0A0A0B",
                        color: lm ? "@darkerGrey" : theme.colors.mainBackground,
                        display: "block",
                        position: "absolute",
                        top: 40,
                        border: "1px solid " + lm ? "#e4e3e3" : lightenColor({ theme }, theme.colors.darkerGrey, 80),
                        fontSize: "1em",
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        zIndex: 3000
                    },
                    suggestionsList: {
                        margin: 0,
                        padding: 0,
                        listStyleType: "none",
                        paddingTop: 0,
                        paddingBottom: 0
                    },
                    suggestion: {
                        paddingTop: 10,
                        paddingBottom: 10,
                        paddingLeft: 10,
                        cursor: "pointer"
                    },
                    suggestionHighlighted: {
                        background: p.accent ?? theme.colors.accent,
                        backgroundColor: p.accent ?? theme.colors.accent,
                        color: theme.colors.mainBackground,
                        borderLeft: ""
                    }
                }}
                onEnterPressed={onEnterPressed}

            />
            {
                search !== "" && search !== undefined &&
                <TubeSC.TSSearchDelete
                    onClick={search !== "" ? resetSearchStr : undefined}
                >
                    <Icon marginTop={9} name="times" size="20px" />
                </TubeSC.TSSearchDelete>
            }
        </TubeSC.TSAuto>
    );
}



export type SearchPostType = "certificates" | "playlists" | "competencies";

interface SearchPostsProps {
    type: SearchPostType;
    onSearch: (post: PostDownloadDto) => void;
}

const gtForType = (type: SearchPostType) => {
    switch (type) {
        case "certificates":
            return "PLAYLIST";
        case "playlists":
            return "PLAYLIST";
        case "competencies":
            return "COMPETENCE";
        default:
            return "PODCAST";
    }
};

const filterForType = (type: SearchPostType) => {
    switch (type) {
        case "certificates":
            return { includedPostTypes: ["LearnerCertificate"] } as FetchPostsFilter;
        case "playlists":
            return { includedPostTypes: ["Playlist"] } as FetchPostsFilter;
        case "competencies":
            return { includedPostTypes: ["Competence"] } as FetchPostsFilter;
        default:
            return {};
    }
}


type SState = {
    filter: FetchPostsFilter;
    groupType: string;
}

type SActions =
    | { type: "batch", value: SActions[] }
    | { type: "set_groupType", value: string }
    | { type: "set_filter", value: FetchPostsFilter }
    ;

const reducer = (state: SState, action: SActions): SState => {
    switch (action.type) {
        case 'batch':
            return reducerBatchJob(state, action.value, reducer);
        case 'set_groupType':
            return reducerSetIfChanged(state, "groupType", action.value);
        case 'set_filter':
            return reducerSetIfChanged(state, "filter", action.value);
    }
}

const SE = styled.div`
    //display: grid;
    //grid-template-columns: max-content 1fr;
    min-height: 60px;
    max-height: 100%;
    overflow-y: auto;
    line-height: 40px;
`;
const Row = styled.div`
cursor: pointer;
    &:hover{
        background: ${p => getColor(p, "@veryLightGrey")};
    }
`;

const setCategoriesAndCategoryStack = (categories: CategoryDownloadDto[] | undefined, categoryStack: ElementNode<CategoryDownloadDto>[] | undefined) => {
};

const SearchPosts = (p: SearchPostsProps) => {
    const contentLanguage = useAppSelector(s => s.contentLanguage);
    const { type, onSearch } = p;
    const [search, setSearch] = React.useState<string>();
    const [posts, setPosts] = React.useState<PostDownloadDto[]>();
    const [state, d] = React.useReducer(reducer, { filter: { includedPostTypes: ["X"] }, groupType: "CONFIGURATION" });
    const [scrollHelper] = React.useState(new ScrollHelper());
    const { t } = useImgI18N("playlist");

    //const {t, currentLanguage, currentNamespace, changeLanguage, createT, imgI18NUpdateCounter } = useImgI18N("general");
    //const {} = useSelector(mapper, shallowCompare);

    React.useEffect(() => {
        d({
            type: "batch", value: [
                { type: "set_groupType", value: gtForType(type) },
                { type: "set_filter", value: filterForType(type) }
            ]
        });
        setPosts(undefined);
        setSearch("");
    }, [type]);

    const { filter, groupType } = state;

    const {
        currentFilter,
        containerDivProps
    } = useSearchableFeed({
        groupType,
        filter,
        posts,
        setPosts,
        setSearch,
        setCategoriesAndCategoryStack,
        categoryMapName: "",
        scrollHelper,
        search,
        withBookmarks: true,
        loadingCount: 25,
        ignoreCategoryFilter: true,
        lng: null
    });

    return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr", width: "100%", height: "100%", gridTemplateRows: "50px 1fr", position: "relative" }}>
            <div>
                <SearchField
                    filter={currentFilter}
                    onSearch={setSearch}
                />
            </div>
            <SE className="contentScroll" {...containerDivProps}>
                {!posts ?
                    <div style={{ marginTop: 10 }}>
                        <LoaderInline active infoText={t("loading")} />
                    </div>
                    : _.map(posts, (t, i) => {
                        return (
                            <Row key={i} onClick={() => onSearch(t)}>
                                <Button icon="add" kind="transparentButton" floated="left" />
                                <span style={{ paddingLeft: 10 }}>{stripHtml(getTranslated(t.headlines, contentLanguage)?.text ?? "")}</span>
                            </Row>
                        );
                    }
                    )}
            </SE>
        </div>
    )
}

export default SearchPosts;